var n=function(n,r){return Object.assign(n,r)};export{n as withStaticProps};
